<template>
  <vs-card class="content-card" :class="{ disable: isDisconnect }">
    <div class="control">
      <div class="title-task">
        <div>
          <vs-icon icon="ac_unit" color="#007bff"></vs-icon>
          <span>Air-condition status</span>
        </div>
        <div>
          <vs-icon
            @click="openPopup"
            class="btn-icon"
            icon="today"
            color="#007bff"
          ></vs-icon>
          <vs-popup
            class="holamundo"
            title="Schedule Air condition"
            :active.sync="popupActivo"
            background-color-popup="var(--background-color-sidebar)"
          >
            <div class="add-schedule">
              <CardSchedule :schedule="schedule" :type="'view'" />
            </div>
          </vs-popup>
        </div>
      </div>
      <div class="swift">
        <div>
          <vs-button
            color="#cecece"
            type="filled"
            icon="remove"
            @click="onReduce"
            v-if="noTemp!=true"
          ></vs-button>
        </div>
        <div class="circle-control">
          <div class="item-air">
            <circle-slider
              :side="130"
              v-model="val3"
              progress-color="#ffc107"
              :progress-width="3"
              :knob-radius="5"
              knob-color="#ffc107"
              circle-color="#fff"
              :max="30"
              :min="17"
              class="circle-slider"
            >
            </circle-slider>
            <div class="stack">
              <p v-if="noTemp!=true">+{{ val3 }}°C</p>
              <span>Air Conditioner</span>
              <vs-switch
                v-model="switch1"
                color="#ffc107"
                :disabled="isDisconnect"
                @click="onAir"
              >
                <span slot="on">On</span>
                <span slot="off">Off</span>
              </vs-switch>
            </div>
          </div>
        </div>
        <div>
          <vs-button
            color="#007bff"
            type="filled"
            icon="add"
            @click="onIncrease"
            v-if="noTemp!=true"
          ></vs-button>
        </div>
      </div>
      <!-- <div class="mode-wind">
        <div>
          mode<vs-button
            radius
            color="#007bff"
            type="border"
            :icon="mode_icon_arr[mode]"
            @click="ChangeMode"
          ></vs-button>
        </div>
        <div>
          wind<vs-button
            radius
            color="#007bff"
            type="border"
            icon="search"
          ></vs-button>
        </div>
      </div> -->
    </div>
  </vs-card>
</template>

<script>
import { clearTimeout } from 'highcharts';
import CardSchedule from "./CardSchedule.vue";

export default {
  props: {
    isDisconnect: { type: Boolean, default: true },
    device_id: {
      type: String,
      default: undefined,
    },

    schedule: {
      type: [Array, Object],
      default: [],
    },
  },
  components: {
    CardSchedule,
  },
  data() {
    return {
      val3: 0,
      val3Before: 0,
      statusOnTemp: false,
      switch1: true,
      popupActivo: false,
      isDisconnect: false,
      noTemp:true,

      // mode:0,
    };
  },
  watch: {
    val3: function () {
      if (this.statusOnTemp == true) {
        if (this.val3 != this.val3Before) {
          console.log(this.val3);
          this.onTemp();
        }
        // console.log('val3');
      }
    },
  },
  async mounted() {
    // await this.getStatus();
    // await this.getStatus2();
    await this.callData()
    this.statusOnTemp = true;
    // if (this.interval != null) {
    //   clearInterval(this.interval);
    // }
    // this.interval = setInterval(async () => {
    //   await this.getStatus();
    // await this.getStatus2();

    // }, 20 * 1000);
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    clearTimeout(this.interval);
  },
  methods: {
    async callData() {
      await this.getStatus();
      await this.getStatus2();
      this.interval = setTimeout(async () => {
        await this.callData();
      }, 20 * 1000);
    },
    async getStatus() {
      let res = await this.$API.get("tuya/device/status/" + this.device_id);
      console.log(this.device_id, res);
      if (res.status === 200) {
        // this.switch1 = res.data.result.power == 1 ? true : false;
        this.val3 = res.data.result.temp;
        this.val3Before = res.data.result.temp;
        this.isDisconnect = !res.data.success;
        if(this.val3 > 11){
          this.noTemp = false
        }
      }
    },
    async getStatus2() {
      let res = await this.$API.get("tuya/get/air/power/" + this.device_id);
      console.log('getStatus2',this.device_id, res);
      if (res.status === 200) {
        this.switch1 = res.data.status == 'On' ? true : false;
        // this.val3 = res.data.result.temp;
        // this.val3Before = res.data.result.temp;
        // this.isDisconnect = !res.data.success;
      }
    },
    async onAir() {
      console.log(this.switch1);
      // status is value before change
      let status = this.switch1;
      let body = {
        device: this.device_id,
        mode: "power",
        value: status == true ? 0 : 1,
      };
      console.log(body);
      let res = await this.$API.post("tuya/air/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success != true) {
          this.switch1 = status;
        }
      }
    },
    onIncrease() {
      if (this.val3 < 30) {
        this.val3 = this.val3 + 1;
      }
    },
    onReduce() {
      if (this.val3 > 17) {
        this.val3 = this.val3 - 1;
      }
    },
    async onTemp() {
      console.log(this.val3, this.val3Before);
      let temp = this.val3;
      let body = {
        device: this.device_id,
        mode: "temp",
        value: temp,
      };
      console.log(body);
      let res = await this.$API.post("tuya/air/command", body);
      console.log(res);
      if (res.status === 200) {
        if (res.data.success == true) {
          console.log("true", res.data.success);
          this.val3Before = temp;
          if (this.switch1 == false) {
            this.switch1 = true;
          }
        } else {
          console.log("false", res.data.success);

          this.val3 = this.val3Before;
        }
      }
    },
    openPopup() {
      this.$store.dispatch("i_APC/genData");
      this.$store.dispatch("i_APC/getSchedule");
      this.popupActivo = true;
    },
    // ChangeMode(){
    //   console.log(this.mode,this.mode_icon_arr.length);
    //   this.mode < this.mode_icon_arr.length-1 ? this.mode++ : this.mode = 0;
    // },
  },
};
</script>

<style lang="scss" scoped>

.control {
  display: flex;
  flex-direction: column;
  .swift {
    margin: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    gap: 5px;
    .circle-control {
      border-radius: 5000px;
      // padding: 10px;
      // margin: 0 10px 10px 0;
      // background-color: #eb3131;
      width: 130px;
      height: 130px;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      .item-air {
        // width: 100%;
        // height: 100%;
        // display: flex;
        // position: relative;
        // top: -15px;
        // right: 30px;
        .circle-slider {
          position: absolute;
        }
        .stack {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          position: relative;
          top: 10px;
          left: 10px;
          // right: 105px;
          box-shadow: 1px 1px 3px 0.5px #cecece;
          // background: chartreuse;
          border-radius: 500px;
          // width: 100%;
          // height: 100%;
          height: 110px;
          width: 110px;
          .img {
            display: flex;
            justify-content: center;
            img {
              width: 80%;
            }
          }
          p {
            text-align: center;
            margin-bottom: 0px;
            font-size: 2rem;
            color: #007bff;
          }
          span {
            margin-bottom: 3px;
          }
        }
      }
    }
  }
  .mode-wind {
    display: flex;
    gap: 10px;
    justify-content: space-around;
  }
  .title-task {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    div{
      span{
        margin-left: 5px;
      color: #007bff;

      }
    }
  }
}
img {
  width: 200px;
  position: absolute;
}
.btn-icon {
  cursor: pointer;
}
.disable {
  // pointer-events: none;
  background-color: #7c7c7c8c;
  .control {
    .swift {
      pointer-events: none;
    }
  }
}
</style>